import React from 'react';
import Link from 'gatsby-link';

import { Toolbar, Button } from 'react-md';

import './Footer.css';

const FooterItems = () => [
	<Button flat href="/terms-of-use">
		Terms
	</Button>,
	<Button flat href="/privacy-policy">
		Privacy
	</Button>
];

const Footer = () => (
	<Toolbar
		actions={FooterItems()}
		nav={
			<Button flat href="https://www.law.berkeley.edu/experiential/clinics/new-business-community-law-clinic/">
				© 2019 Berkeley Law
			</Button>
		}
		className="footer"
	/>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js